import { defineMessages } from 'react-intl'

export default defineMessages({
  bookCtaTitle: {
    id: 'summarypage.bookCta.title',
    defaultMessage: 'Book an appointment before you download the app',
  },
  bookCtaBody: {
    id: 'summarypage.bookCta.body',
    defaultMessage:
      'Get the first available appointment with a doctor of your choice by booking now, and then downloading the app.',
  },
  bookCtaBtn: {
    id: 'summarypage.bookCta.button',
    defaultMessage: 'Book appointment',
  },
  stepTitle: {
    id: 'summarypage.step_title',
    defaultMessage: 'Make an appointment with Babylon!',
  },
  downloadAppTitle: {
    id: 'summarypage.downloadTheApp.title',
    defaultMessage: 'Download the app for more features',
  },
  downloadAppBody: {
    id: 'summarypage.downloadTheApp.body',
    defaultMessage:
      'Log in on the web or on your phone to book a video appointment — at no cost — through your health plan.',
  },
})
